<template id="screens-display">
    <div id="lobby" class="main" :class="{ 'cursor-none': isInactive }">
        <div class="grid">
            <Sub_LobbyVideoPlayer></Sub_LobbyVideoPlayer>
            <Sub_LobbyWidgets></Sub_LobbyWidgets>
        </div>
        <div class="grid-2">
            <Sub_LobbyMessageBoard></Sub_LobbyMessageBoard>
            <Sub_LobbyDailyMeetings></Sub_LobbyDailyMeetings>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, onUnmounted, ref } from 'vue'
    import Sub_LobbyDailyMeetings     from './Sub_LobbyDailyMeetings.vue'
    import Sub_LobbyMessageBoard      from './Sub_LobbyMessageBoard.vue'
    import Sub_LobbyVideoPlayer       from './Sub_LobbyVideoPlayer.vue'
    import Sub_LobbyWidgets           from './Sub_LobbyWidgets.vue'

    let timeout             = null
    let inactivityTimeout   = null

    const isInactive        = ref(false)

    const resetInactivity = () => {
        isInactive.value = false
        
        clearTimeout(inactivityTimeout)
        inactivityTimeout = setTimeout(() => {
            isInactive.value = true
        }, 1000)
    }

    onMounted(() => {
        document.body.style.overflow = 'hidden'

        timeout = setTimeout(() => {
            window.location.reload()
        }, 1 * 60 * 60 * 1000) // 1 heure

        // Cursor Inactivity
        window.addEventListener('mousemove', resetInactivity)
        window.addEventListener('keydown', resetInactivity)
        resetInactivity()
    })

    onUnmounted(() => {
        document.body.style.overflow = ''

        if (timeout) clearTimeout(timeout)

        // Cursor Inactivity
        window.removeEventListener('mousemove', resetInactivity)
        window.removeEventListener('keydown', resetInactivity)

        if (inactivityTimeout) clearTimeout(inactivityTimeout)
    })
</script>

<style lang="scss">
    #lobby {
        height: 100vh;
        background-color: $ciel-blue;

        &.main {
            padding: 1.5vw;
            display: flex;
            flex-direction: column;
            gap: 1.5vw;
            
            .grid {
                display: grid;
                
                grid-template-columns: 3fr 1fr;
                gap: 1.5vw;
            }
            
            .grid-2 {
                display: grid;
                
                grid-template-columns: 1fr 40vw;
            gap: 1.5vw;
            
            align-items: top;
        }

        .grid-2:not(:has(> :nth-child(2))) {
            grid-template-columns: 1fr;
        }
    }

}

.cursor-none {
    cursor: none;
}
</style>